import axios from 'axios';

// API URL helper - supports custom domains
// Always computes URL dynamically to support custom domain access
export const getApiUrl = () => {
  // In browser environment
  if (typeof window !== 'undefined') {
    // On localhost (development), use the env variable
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return `${process.env.REACT_APP_BACKEND_URL}/api`;
    }
    // On any other domain (production/preview/custom domain), use current origin
    // The nginx/ingress handles /api routing to the backend
    return `${window.location.origin}/api`;
  }
  // Fallback for SSR or non-browser environments
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const getWsUrl = () => {
  if (typeof window !== 'undefined') {
    // On localhost (development), use the env variable  
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL
        .replace('https://', 'wss://')
        .replace('http://', 'ws://') + '/api/ws/sync';
    }
    // On any other domain (production/preview/custom domain), use current origin
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/api/ws/sync`;
  }
  return process.env.REACT_APP_BACKEND_URL
    .replace('https://', 'wss://')
    .replace('http://', 'ws://') + '/api/ws/sync';
};

// Setup axios interceptor to always include auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// IMPORTANT: Do not use this constant - always call getApiUrl() directly
// to ensure the URL is computed fresh for the current domain
export const API = getApiUrl();
